import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

export interface DpiCard {
  id: string;
  icon: string;
  title: string;
  description: string;
}

@Component({
  selector: 'app-mahaagx-dpi',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './mahaagx-dpi.component.html',
  styleUrl: './mahaagx-dpi.component.scss',
})
export class MahaagxDpiComponent {
  cards: DpiCard[] = [
    {
      id: 'foundational',
      icon: '/about-us/DPI/layer.svg',
      title: 'Foundational Trust Layer',
      description: 'Acts as a neutral, state-led trust layer enabling secure and governed agricultural data exchange at scale.',
    },
    {
      id: 'interoperable',
      icon: '/about-us/DPI/share.svg',
      title: 'Open & Interoperable',
      description: 'Built on open standards to ensure interoperability & scalability across departments, institutions, and innovators.',
    },
    {
      id: 'privacy',
      icon: '/about-us/DPI/ShieldCheck.svg',
      title: 'Privacy-driven by Design',
      description: 'Enables purpose-specific, auditable data sharing while protecting farmer data rights.',
    },
  ];
}
